/* Ravie sparkle · v1.1 · Oct 22, 2026
   Softly falling, glistening flecks in the Softlight shades (Soft Pink, Soft Gold, Soft Pearl),
   and small glints of light that come and go on a photo.
   Each fleck is a tiny flat flake that turns as it falls and flashes when it catches the light.
   Used by sections/ravie-launch.liquid (Hero block > Falling flecks, Glints). Notes: Glines HQ > Website > Website Notes, 6A.

   Flecks in one area: an element with data-rv-sparkle="gentle" (keeps falling) or "moment" (about 7 seconds)
   gets flecks behind its text. Options on the same element:
     data-rv-ground   "light" for cream or white backgrounds (default), "dark" for photos and film
     data-rv-density  0.3 to 1.5 (default 1)
     data-rv-bleed    "false" keeps the flecks inside the element instead of the full screen width
   The element needs position: relative. Its text needs position: relative and z-index: 2.

   Flecks on the whole page (new in v1.1): an element with data-rv-sparkle-page="gentle" (keeps falling) or
   "shower" (about twice as many for the first 6 seconds, then gentle). One screen-size layer: the flecks start
   at the very top and keep falling the whole way down, drifting a little as you scroll so they feel part of
   the page. It sits under the menu, the cart and pop-ups (data-rv-z, default 25; the sticky header is 20)
   and never blocks a tap. data-rv-ground and data-rv-density work here too.

   Glints (new in v1.1): an element with data-rv-glints="x,y,r; x,y,r" gets small stars of light that come and go
   inside those circles, like light catching the glitter in a photo. x and y are percent of the element's width and
   height, r is percent of its width. The element needs position: relative.

   By hand: ravieSparkle({ host, page, ground, moment, shower, density, bleed, z, max, force, now })
              returns { count, burst(x, y, n), destroy } or null. burst() throws a few flecks out from a point.
            ravieGlints({ host, spots: [[x, y, r], ...], force, now }) returns { destroy } or null.
   Off for visitors who turn motion off or use data saver. Pauses when the tab is hidden or the area is off screen.
   Starts after the page has loaded. */
(function () {
  if (window.ravieSparkle && window.ravieGlints) return;

  function quiet() {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return true;
    return !!(navigator.connection && navigator.connection.saveData);
  }
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };
  function whenLoaded(f, now) {
    if (now) f();
    else if (document.readyState === 'complete') idle(f, { timeout: 1500 });
    else window.addEventListener('load', function () { idle(f, { timeout: 1500 }); }, { once: true });
  }
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function sprite(size, draw) { var c = document.createElement('canvas'); c.width = c.height = size; draw(c.getContext('2d'), size); return c; }

  function ravieSparkle(o) {
    o = o || {};
    var page = !!o.page, host = page ? null : (o.host || null);
    var ground = o.ground === 'dark' ? 'dark' : 'light';
    var moment = page ? false : o.moment !== false, density = o.density || 1, bleed = o.bleed !== false;
    var SHOWER = o.shower ? (o.shower === true ? 6000 : +o.shower) : 0, BOOST = 1.9;
    var RUN = 7000, FADE_IN = 900, FADE_OUT = 1800;
    if (!o.force && quiet()) return null;

    var cv = document.createElement('canvas');
    cv.setAttribute('aria-hidden', 'true');
    cv.className = page ? 'rv-fx rv-fx--page' : 'rv-fx';
    cv.style.cssText = page
      ? 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:' + (parseInt(o.z, 10) || 25) + ';'
      : host
        ? 'position:absolute;top:0;height:100%;pointer-events:none;z-index:1;' + (bleed ? 'left:calc(50% - 50vw);width:100vw;' : 'left:0;width:100%;')
        : 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:2147483000;';
    (host || document.body).appendChild(cv);
    var ctx = cv.getContext('2d');
    if (!ctx) { cv.remove(); return null; }
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, parts = [], baseN = 0, raf = 0, last = 0, t0 = 0, endAt = 0, dead = false, done = false;
    var hidden = document.hidden, inView = true, io = null, ro = null, lastY = window.scrollY || 0;

    /* Shade colors. Light grounds use a deeper body so the flecks read on cream. */
    var SHADES = ground === 'dark'
      ? [[236, 202, 204], [218, 198, 178], [238, 238, 236]]
      : [[214, 140, 153], [190, 148, 90], [158, 165, 184]];
    var GLINT = ground === 'dark' ? '255,255,255' : '255,250,242';
    var RAY = ground === 'dark' ? '255,255,255' : '201,163,104';

    function glow(rgb) {
      return sprite(64, function (g) {
        var r = g.createRadialGradient(32, 32, 0, 32, 32, 32);
        r.addColorStop(0, 'rgba(' + GLINT + ',1)');
        r.addColorStop(0.16, 'rgba(' + GLINT + ',.92)');
        r.addColorStop(0.42, 'rgba(' + rgb + ',.5)');
        r.addColorStop(1, 'rgba(' + rgb + ',0)');
        g.fillStyle = r; g.fillRect(0, 0, 64, 64);
      });
    }
    var HALO = ground === 'dark' ? SHADES : [[236, 186, 194], [222, 192, 140], [214, 218, 230]];
    var glows = HALO.map(function (c) { return glow(c.join(',')); });
    var flare = sprite(64, function (g) {
      var h = g.createLinearGradient(0, 0, 64, 0);
      h.addColorStop(0, 'rgba(' + RAY + ',0)'); h.addColorStop(0.5, 'rgba(' + RAY + ',.95)'); h.addColorStop(1, 'rgba(' + RAY + ',0)');
      g.fillStyle = h; g.fillRect(0, 31, 64, 2);
      var v = g.createLinearGradient(0, 0, 0, 64);
      v.addColorStop(0, 'rgba(' + RAY + ',0)'); v.addColorStop(0.5, 'rgba(' + RAY + ',.95)'); v.addColorStop(1, 'rgba(' + RAY + ',0)');
      g.fillStyle = v; g.fillRect(31, 0, 2, 64);
    });

    function measure() {
      W = cv.clientWidth || (host ? host.clientWidth : window.innerWidth);
      H = cv.clientHeight || (host ? host.clientHeight : window.innerHeight);
      cv.width = Math.max(1, Math.round(W * dpr)); cv.height = Math.max(1, Math.round(H * dpr));
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function count() {
      var n = Math.round(W * H / 5200 * density);
      if (!moment) n = Math.round(n * 0.6);
      return Math.max(10, Math.min(o.max || Math.round(56 * density), n));
    }
    /* How many flecks to keep: during a shower there are more, easing back to the usual number. */
    function target(now) {
      if (!SHOWER || !t0) return SHOWER ? Math.round(baseN * BOOST) : baseN;
      var k = Math.max(0, 1 - (now - t0) / SHOWER);
      return Math.round(baseN * (1 + (BOOST - 1) * k));
    }
    function make(p, anywhere) {
      p = p || {};
      p.x0 = rnd(0, W); p.y = anywhere ? rnd(-10, H) : rnd(-24, -6);
      p.k = (Math.random() * 3) | 0;
      p.r = rnd(1.4, 4.2); p.vy = rnd(8, 18); p.sway = rnd(3, 10); p.f = rnd(0.12, 0.35); p.ph = rnd(0, 6.283);
      p.th = rnd(0, 6.283); p.spin = rnd(1.2, 3.2) * (Math.random() < 0.5 ? -1 : 1); p.rot = rnd(0, 3.14);
      p.a = rnd(0.6, 0.95); p.star = Math.random() < 0.3;
      p.depth = 0.12 + (p.r - 1.4) / 2.8 * 0.36; /* bigger flecks are "closer", so they drift more as you scroll */
      p.bx = 0; p.by = 0;
      return p;
    }
    function seed() {
      baseN = count(); parts = [];
      for (var i = 0, n = target(0); i < n; i++) parts.push(make(null, true));
    }

    function tick(now) {
      raf = 0;
      if (dead || hidden || !inView) return;
      if (!t0) { t0 = now; last = now; endAt = now + RUN; }
      var dt = Math.min(0.05, (now - last) / 1000); last = now;
      var fadeIn = Math.min(1, (now - t0) / FADE_IN);
      var fadeOut = moment && now > endAt ? Math.max(0, 1 - (now - endAt) / FADE_OUT) : 1;
      var s = now / 1000, keep = target(now), damp = Math.pow(0.03, dt);
      ctx.clearRect(0, 0, W, H);
      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i];
        if (p.bx || p.by) { p.x0 += p.bx * dt; p.y += p.by * dt; p.bx *= damp; p.by *= damp; if (Math.abs(p.bx) + Math.abs(p.by) < 2) { p.bx = 0; p.by = 0; } }
        p.y += p.vy * dt; p.th += p.spin * dt;
        if (p.y > H + 12) {
          if (parts.length > keep) parts.splice(i, 1);
          else if (!moment || now < endAt) make(p, false);
          continue;
        }
        var x = p.x0 + Math.sin(s * p.f * 6.283 + p.ph) * p.sway;
        var a = p.a * fadeIn * fadeOut;
        if (a < 0.01) continue;
        var face = Math.abs(Math.cos(p.th));
        var flash = Math.pow(face, 6);
        var c = SHADES[p.k];
        var ang = p.rot + p.th * 0.15;
        var ry = Math.max(p.r * 0.28, p.r * face);
        /* the flake itself, seen edge-on or face-on as it turns */
        ctx.globalAlpha = a * (0.6 + 0.4 * face);
        ctx.fillStyle = 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')';
        ctx.beginPath();
        ctx.ellipse(x, p.y, p.r, ry, ang, 0, 6.283);
        ctx.fill();
        /* its bright face as it turns toward the light */
        if (face > 0.55) {
          ctx.globalAlpha = a * (face - 0.55) / 0.45;
          ctx.fillStyle = 'rgb(' + GLINT + ')';
          ctx.beginPath();
          ctx.ellipse(x - p.r * 0.18, p.y - ry * 0.2, p.r * 0.5, ry * 0.45, ang, 0, 6.283);
          ctx.fill();
        }
        /* the glint when it faces the light */
        if (flash > 0.3) {
          var d = p.r * (ground === 'dark' ? 8 : 6.5) * (0.6 + 0.4 * flash);
          ctx.globalAlpha = a * flash;
          ctx.drawImage(glows[p.k], x - d / 2, p.y - d / 2, d, d);
          if (p.star && flash > 0.82) {
            var L = p.r * (ground === 'dark' ? 10 : 8);
            ctx.globalAlpha = a * Math.min(1, (flash - 0.82) / 0.12);
            ctx.drawImage(flare, x - L / 2, p.y - L / 2, L, L);
          }
        }
      }
      ctx.globalAlpha = 1;
      if (moment && now > endAt + FADE_OUT) { done = true; ctx.clearRect(0, 0, W, H); return; }
      raf = requestAnimationFrame(tick);
    }
    function play() { if (!raf && !dead && !done && !hidden && inView) raf = requestAnimationFrame(function (n) { last = n; tick(n); }); }
    function onVis() { hidden = document.hidden; if (!hidden) play(); }
    function onResize() { var w = W, h = H; measure(); if (Math.abs(w * h - W * H) > W * H * 0.25) seed(); }
    /* Whole page: as you scroll, the flecks drift with the page a little (bigger ones more), then wrap around. */
    function onScroll() {
      var y = window.scrollY || 0, dy = y - lastY; lastY = y;
      if (!dy || dy > H || dy < -H) return;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.y -= dy * p.depth;
        if (p.y < -30) p.y += H + 40; else if (p.y > H + 30) p.y -= H + 40;
      }
    }

    function begin() {
      if (dead) return;
      measure(); seed();
      document.addEventListener('visibilitychange', onVis);
      if ('ResizeObserver' in window) { ro = new ResizeObserver(onResize); ro.observe(cv); }
      else window.addEventListener('resize', onResize);
      if (page) window.addEventListener('scroll', onScroll, { passive: true });
      else if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (es) { inView = es[0].isIntersecting; play(); });
        io.observe(host || cv);
      }
      play();
    }
    whenLoaded(begin, o.now);

    return {
      count: function () { return parts.length; },
      /* Throw a few flecks out from a point (in the layer's own pixels), then let them fall. */
      burst: function (x, y, n) {
        if (dead || done || !W) return;
        for (var i = 0, m = n || 12; i < m; i++) {
          var p = make(null, false), ang = rnd(0, 6.283), sp = rnd(50, 150);
          p.x0 = x; p.y = y; p.bx = Math.cos(ang) * sp; p.by = Math.sin(ang) * sp - 30; p.a = rnd(0.75, 1);
          parts.push(p);
        }
        play();
      },
      destroy: function () {
        dead = true; if (raf) cancelAnimationFrame(raf);
        document.removeEventListener('visibilitychange', onVis);
        window.removeEventListener('resize', onResize);
        window.removeEventListener('scroll', onScroll);
        if (ro) ro.disconnect(); if (io) io.disconnect();
        cv.remove();
      }
    };
  }

  /* Glints: small stars of light that come and go inside a few circles on a photo. */
  var STAR = null, HALO_W = null;
  function glintSprites() {
    if (STAR) return;
    STAR = sprite(128, function (g, s) {
      var c = s / 2;
      function ray(len, wid, rot, alpha) {
        g.save(); g.translate(c, c); g.rotate(rot);
        var lg = g.createLinearGradient(-len, 0, len, 0);
        lg.addColorStop(0, 'rgba(255,255,255,0)'); lg.addColorStop(0.5, 'rgba(255,255,255,' + alpha + ')'); lg.addColorStop(1, 'rgba(255,255,255,0)');
        g.fillStyle = lg;
        g.beginPath(); g.moveTo(-len, 0); g.lineTo(0, -wid); g.lineTo(len, 0); g.lineTo(0, wid); g.closePath(); g.fill();
        g.restore();
      }
      ray(c, 2.6, 0, 1); ray(c, 2.6, Math.PI / 2, 1);
      ray(c * 0.42, 1.6, Math.PI / 4, 0.7); ray(c * 0.42, 1.6, -Math.PI / 4, 0.7);
      var r = g.createRadialGradient(c, c, 0, c, c, 10);
      r.addColorStop(0, 'rgba(255,255,255,1)'); r.addColorStop(1, 'rgba(255,255,255,0)');
      g.fillStyle = r; g.fillRect(c - 10, c - 10, 20, 20);
    });
    HALO_W = sprite(64, function (g) {
      var r = g.createRadialGradient(32, 32, 0, 32, 32, 32);
      r.addColorStop(0, 'rgba(255,252,246,.95)'); r.addColorStop(0.3, 'rgba(255,240,222,.5)'); r.addColorStop(1, 'rgba(255,236,214,0)');
      g.fillStyle = r; g.fillRect(0, 0, 64, 64);
    });
  }

  function ravieGlints(o) {
    o = o || {};
    var host = o.host, spots = [];
    (o.spots || []).forEach(function (s) {
      var x = +s[0], y = +s[1], r = +s[2];
      if (x >= 0 && x <= 100 && y >= 0 && y <= 100 && r > 0) spots.push([x / 100, y / 100, r / 100]);
    });
    if (!host || !spots.length) return null;
    if (!o.force && quiet()) return null;
    glintSprites();
    var cv = document.createElement('canvas');
    cv.setAttribute('aria-hidden', 'true');
    cv.className = 'rv-glints';
    cv.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:1;';
    host.appendChild(cv);
    var ctx = cv.getContext('2d');
    if (!ctx) { cv.remove(); return null; }
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, gl = [], next = 0, raf = 0, last = 0, dead = false, hidden = document.hidden, inView = true, io = null, ro = null;

    function measure() {
      W = cv.clientWidth || host.clientWidth; H = cv.clientHeight || host.clientHeight;
      cv.width = Math.max(1, Math.round(W * dpr)); cv.height = Math.max(1, Math.round(H * dpr));
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function spawn(now) {
      var s = spots[(Math.random() * spots.length) | 0];
      var a = rnd(0, 6.283), d = Math.sqrt(Math.random()) * s[2] * 0.82 * W;
      gl.push({ x: s[0] * W + Math.cos(a) * d, y: s[1] * H + Math.sin(a) * d, t0: now, life: rnd(650, 1250), L: Math.max(16, W * rnd(0.04, 0.075)), rot: rnd(-0.3, 0.3) });
    }
    function tick(now) {
      raf = 0;
      if (dead || hidden || !inView) return;
      if (!next) next = now + 250;
      if (now >= next) { spawn(now); next = now + rnd(170, 430); }
      ctx.clearRect(0, 0, W, H);
      for (var i = gl.length - 1; i >= 0; i--) {
        var g = gl[i], t = (now - g.t0) / g.life;
        if (t >= 1) { gl.splice(i, 1); continue; }
        var k = Math.sin(Math.PI * t); k = k * k;
        var L = g.L * (0.5 + 0.5 * k);
        ctx.globalAlpha = 0.75 * k;
        ctx.drawImage(HALO_W, g.x - L * 0.32, g.y - L * 0.32, L * 0.64, L * 0.64);
        ctx.save(); ctx.translate(g.x, g.y); ctx.rotate(g.rot + t * 0.5);
        ctx.globalAlpha = k;
        ctx.drawImage(STAR, -L / 2, -L / 2, L, L);
        ctx.restore();
      }
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(tick);
    }
    function play() { if (!raf && !dead && !hidden && inView) raf = requestAnimationFrame(function (n) { last = n; tick(n); }); }
    function onVis() { hidden = document.hidden; if (!hidden) play(); }
    function begin() {
      if (dead) return;
      measure();
      document.addEventListener('visibilitychange', onVis);
      if ('ResizeObserver' in window) { ro = new ResizeObserver(measure); ro.observe(cv); }
      else window.addEventListener('resize', measure);
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (es) { inView = es[0].isIntersecting; play(); });
        io.observe(host);
      }
      play();
    }
    whenLoaded(begin, o.now);
    return {
      destroy: function () {
        dead = true; if (raf) cancelAnimationFrame(raf);
        document.removeEventListener('visibilitychange', onVis);
        window.removeEventListener('resize', measure);
        if (ro) ro.disconnect(); if (io) io.disconnect();
        cv.remove();
      }
    };
  }

  function parseSpots(v) {
    return String(v || '').split(';').map(function (t) { return t.split(','); }).filter(function (t) { return t.length === 3; });
  }

  function initAll(root) {
    root = root || document;
    var els = root.querySelectorAll('[data-rv-sparkle]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__rvSparkle !== undefined) continue;
      var mode = el.getAttribute('data-rv-sparkle');
      if (mode !== 'gentle' && mode !== 'moment') { el.__rvSparkle = null; continue; }
      el.__rvSparkle = ravieSparkle({
        host: el,
        ground: el.getAttribute('data-rv-ground'),
        moment: mode === 'moment',
        density: parseFloat(el.getAttribute('data-rv-density')) || 1,
        bleed: el.getAttribute('data-rv-bleed') !== 'false'
      });
    }
    var pg = root.querySelectorAll('[data-rv-sparkle-page]');
    for (var j = 0; j < pg.length; j++) {
      var p = pg[j], m = p.getAttribute('data-rv-sparkle-page');
      if (p.__rvSparkle !== undefined) continue;
      if ((m !== 'gentle' && m !== 'shower') || window.__rvPageFx) { p.__rvSparkle = null; continue; }
      p.__rvSparkle = window.__rvPageFx = ravieSparkle({
        page: true,
        shower: m === 'shower',
        ground: p.getAttribute('data-rv-ground'),
        density: parseFloat(p.getAttribute('data-rv-density')) || 1,
        z: p.getAttribute('data-rv-z')
      });
    }
    var gs = root.querySelectorAll('[data-rv-glints]');
    for (var k = 0; k < gs.length; k++) {
      var g = gs[k];
      if (g.__rvGlints !== undefined) continue;
      g.__rvGlints = ravieGlints({ host: g, spots: parseSpots(g.getAttribute('data-rv-glints')) });
    }
  }

  window.ravieSparkle = ravieSparkle;
  window.ravieGlints = ravieGlints;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Theme editor: start again after a section re-renders, and stop before it goes away. */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var els = e.target.querySelectorAll('[data-rv-sparkle], [data-rv-sparkle-page], [data-rv-glints]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__rvSparkle) el.__rvSparkle.destroy();
      if (el.__rvGlints) el.__rvGlints.destroy();
      if (el.__rvSparkle && el.__rvSparkle === window.__rvPageFx) window.__rvPageFx = null;
      el.__rvSparkle = undefined; el.__rvGlints = undefined;
    }
  });
})();
